var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.open()}}},[_vm._v("AIお勧め検索で利用可能な主傷病一覧")])}
var staticRenderFns = []

export { render, staticRenderFns }